import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// native components
import LeadersTwoColumnContent from '../leadersTwoColumnContent';
// images
import profilePicWebp from './images/cio-jeb-bentley.webp';
// styles
import {
  LinkedinStyledSocialIcon,
  LinkStyledBio,
} from '../../styles';

export default () => {
  const name = 'John E. (Jeb) Bentley';
  const nameString = 'jeb-bentley';
  const title = 'Chief Investment Officer';

  return (
    <LeadersTwoColumnContent
      id='leaders-chief-investment-officer'
      header={name}
      title={title}
      isExecutiveVicePresident
      content={(
        <>
          <Typography
            itemprop='description'
            nextElement='link'>
            Jeb oversees the institutional investment team responsible for managing more than &#36;300 billion of the company&#39;s assets, including the general account portfolio, which contributes significantly to the company&#39;s exceptional financial strength and industry&#45;leading product value.
          </Typography>
          <LinkStyledBio
            id={`leaders-section-${nameString}-bio-pdf-link`}
            linkUrl='/assets/pdf/leaders/bentley-jeb-bio.pdf'
            ariaLabel={`Download the bio pdf for ${name}`}
            isInternalPdf
            endAdornment={CaratRight}
            endAdornmentStylesReset
            variant='buttonLinkTertiary'>
            See full bio
          </LinkStyledBio>
          <Row>
            <Col nested>
              <Link
                id={`leaders-section-${nameString}-linkedin-social-link`}
                variant='primary'
                linkUrl='https://www.linkedin.com/in/jebbentley27/'
                ariaLabel={`${name} Linkedin profile`}
                isOutgoingLink>
                <LinkedinStyledSocialIcon />
              </Link>
            </Col>
          </Row>
        </>
      )}
      image={profilePicWebp}
      imageAlt={`Northwestern Mutual Executive Vice President and ${title} ${name}.`}
      reversed
    />
  );
};
